const isLogin = (state) => state.isLogin;
const isSmtLogin = (state) => state.isSmtLogin;
const isConcurrentLogin = (state) => state.isConcurrentLogin;
const isTokenExpiration = (state) => state.isTokenExpiration;
const loginUser = (state) => state.loginUser;
const loginUserNm = (state) => state.loginUser.userNm;
const curCmpnNm = (state) => state.loginUser.curCmpnNm;
const curCmpnId = (state) => state.loginUser.curCmpnId;
const userTrial = (state) => state.loginUser && state.loginUser.trialYn && state.loginUser.trialYn == 'Y' && state.loginUser.trialRemainDays > 0;
const menuAuth = (state) => state.GOV_MENU_AUTH;
const complianceHistory = (state) => state.browserHistory.compliance;
const policyHistory = (state) => state.browserHistory.policy;
const auditHistory = (state) => state.browserHistory.audit;
const isNotWL = (state) => state.loginUser.siteCd === 'BESPIN'; // || state.loginUser.siteCd === 'BGUSA' || state.loginUser.siteCd === 'BGMEA'
const siteCd = (state) => state.loginUser.siteCd;
export default {
  siteCd,
  isLogin,
  isConcurrentLogin,
  isSmtLogin,
  isTokenExpiration,
  loginUser,
  loginUserNm,
  curCmpnNm,
  curCmpnId,
  userTrial,
  complianceHistory,
  policyHistory,
  auditHistory,
  isNotWL
};



// WEBPACK FOOTER //
// ./src/store/modules/user/getters.js